import { Serializer } from "@/core/shared/api/domain/serializers";
import { RegisterMode, UserData } from "@/core/user/domain/userRepository";

interface UserCreateDto {
  mode: "auto" | "assisted";
  claims: { user_type?: string; email?: string; acs_id?: string; id_token?: string };
  action: "confirm";
}

export const userDataSerializer: Serializer<{ userData: UserData; registerMode: RegisterMode }, UserCreateDto> = {
  encode: data => {
    return {
      mode: data.registerMode,
      claims: {
        user_type: data.userData.userType,
        email: data.userData.email,
        acs_id: data.userData.acsId,
        id_token: data.userData.idToken,
      },
      action: "confirm",
    };
  },
};
